import React from 'react';
import { Link } from 'react-router-dom';

// scss
import './SubHeader.scss';

type Props = {
  active: number,
}

const Header: React.FC<Props> = (props) => {
  return (
    <div id="SubHeader">
      <div className="subHeaderWrapper">
        <ul>
          <li className={props.active===2 ? 'active' : ''}><Link to="/digital/fair2021/showroom/activity.html">７つのアクティビティで見る</Link></li>
          <li className={props.active===1 ? 'active' : ''}><Link to="/digital/fair2021/showroom/floormap.html">フロアマップから見る</Link></li>
          <li className={props.active===3 ? 'active' : ''}><Link to="/digital/fair2021/showroom/new.html">展示商品を確認する</Link></li>
        </ul>
      </div>
    </div>
  );
}

export default Header;
